// Centralized station / stream / partner URLs.
// Single source of truth — referenced from Home, Footer, OtherLinks, NowPlayingCard, PWASpotlight.

export const CONTACT_EMAIL = 'majesticjukebox@gmail.com';

export const STREAMS = {
  // Primary MP3 320 kbps stream (streamradio.fr)
  majesticHD:  'https://manager11.streamradio.fr:2485/stream',
  // Alternative AAC stream (internet-radio.com)
  majesticAAC: 'https://uk3.internet-radio.com/proxy/majesticjukebox/stream',
  // Jazz Razzmatazz partner station
  jazz:        'https://puma.streemlion.com:2680/stream',
};

export const STATUS = {
  majesticHD: 'https://manager11.streamradio.fr:2485/status-json.xsl',
  jazz:       'https://puma.streemlion.com:2680/status-json.xsl',
};

// PWA (Progressive Web App) versions of each station
export const PWA = {
  majestic: 'https://majesticjukeboxradio.netlify.app/',
  jazz:     'https://jazzrazzmatazzradio.netlify.app/',
};

// External "Other links" — playlist files for native desktop players
export const PLAYER_LINKS = [
  {
    id: 'winamp',
    label: 'Winamp / iTunes',
    href: 'https://control.internet-radio.com:2199/tunein/majesticjukebox.pls',
    blurb: 'Open a .pls playlist in Winamp or iTunes',
    color: '#F59E0B',
  },
  {
    id: 'wmp',
    label: 'Windows Media Player',
    href: 'https://control.internet-radio.com:2199/tunein/majesticjukebox.asx',
    blurb: '.asx file for Windows Media Player',
    color: '#3B82F6',
  },
  {
    id: 'realplayer',
    label: 'Real Player',
    href: 'https://control.internet-radio.com:2199/tunein/majesticjukebox.ram',
    blurb: '.ram file for RealPlayer',
    color: '#22D3EE',
  },
  {
    id: 'quicktime',
    label: 'QuickTime',
    href: 'https://control.internet-radio.com:2199/tunein/majesticjukebox.qtl',
    blurb: '.qtl file for Apple QuickTime',
    color: '#A78BFA',
  },
  {
    id: 'webplayer',
    label: 'Web Player',
    href: 'https://uk3.internet-radio.com/stream/majesticjukebox/stream.pls',
    blurb: 'Universal stream playlist',
    color: '#10B981',
  },
];

// Partner & social
export const PARTNER_TUNEIN = 'https://tunein.com/radio/Majestic-Jukebox-Radio-s302456/';

export const SOCIAL = {
  facebook: 'https://www.facebook.com/majesticjukebox/',
  youtube:  'https://www.youtube.com/channel/UCko9qJ60eTc4QyOjAgWG7yw',
};

// Donation
export const PAYPAL_URL = 'https://www.paypal.com/donate/?hosted_button_id=LPC97GTZDJJSU';

// Logos / brand
export const LOGOS = {
  majestic: 'https://customer-assets.emergentagent.com/job_radio-jukebox-2/artifacts/u6n2aq57_LOGO%20MAJESTIC%20JUKEBOX%20RADIO%20OK.jpg',
  jazz:     'https://static.wixstatic.com/media/83e446_bb80cf56149c423e95f45fdca3f13591~mv2.jpg',
};
